/**
 * Rodapé "Powered by conducco", presente em todas as telas do fluxo (spec §6).
 *
 * Usa o wordmark horizontal `powered-by-conducco.svg` (380x23, tinta #0F0F1E com
 * acento da marca) — não confundir com `logo-conducco-powered-white.svg`, que é
 * a versão empilhada com o ícone.
 */

import styled from "styled-components";

import poweredByConducco from "assets/powered-by-conducco.svg";

const Footer = styled.footer`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
`;

const Wordmark = styled.img`
  height: 16px;
  width: auto;
  max-width: 100%;
  opacity: 0.7;
`;

export function PoweredByFooter() {
  return (
    <Footer>
      <Wordmark
        src={poweredByConducco}
        alt="Powered by conducco"
      />
    </Footer>
  );
}
